import React from "react";

import OpenSvg from "../../assets/images/icons/open.svg";

export const OpenIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={OpenSvg}
        alt={alt || "Open"}
    />
);
